<template>
    <div>
        <kt-panel-header-toolbar>
            <ul class="nav nav-pills" role="tablist">
                <li class="nav-item">
                    <a :class="['nav-link', currentTab === 1 ? 'active' : '']" href="#psp-info" @click="gotoTab(1)">
                        {{ $t('label.psp_info') }}
                    </a>
                </li>
                <li class="nav-item">
                    <a :class="['nav-link', currentTab === 2 ? 'active' : '']" href="#shaparak-info" @click="gotoTab(2)">
                        {{ $t('label.shaparak-info') }}
                    </a>
                </li>
            </ul>
        </kt-panel-header-toolbar>
        <div class="tab-content">
            <div :class="['tab-pane', currentTab === 1 ? 'active' : '']" id="psp-info">
                <form @submit.prevent="registerTerminal" :id="'register-terminal-' + current_psp_tab">
                    <pspRequests v-if="shop_psp_requests_status === 'success'"/>
                    <kt-row v-if="shop_psp_requests_status === 'success'">
                        <kt-col>
                            <kt-form-action class="mb-4">
                                <button
                                        class="btn btn-md btn-success btn-wide"
                                        type="submit"
                                        id="submit_btn"
                                >
                                    {{ $t('label.register_terminal') }}
                                </button>
                            </kt-form-action>
                        </kt-col>
                    </kt-row>
                </form>
            </div>
            <div :class="['tab-pane', currentTab === 2 ? 'active' : '']" id="shaparak-info">
                <shaparakInfo v-if="shop_shaparak_requests_status === 'success'"/>
                <kt-row>
                    <kt-col>
                        <kt-form-action class="mb-4">
                            <button
                                    class="btn btn-md btn-success btn-wide"
                                    type="button"
                                    id="resend_submit_btn"
                                    @click="sendNewTerminalRequest"
                            >
                                {{ $t('btn.submit_again') }}
                            </button>
                        </kt-form-action>
                    </kt-col>
                </kt-row>
                <kt-row>
                    <kt-col>
                        <shaparak-requests
                                :form_data="form_data"
                                :addresses="addresses"
                                :sheba_numbers="sheba_numbers">
                        </shaparak-requests>
                    </kt-col>
                </kt-row>
            </div>
        </div>
    </div>
</template>

<script>
    import shaparakInfo from './shaparak-info'
    import pspRequests from './psp-requets'
    import {mapGetters} from "vuex";
    import $ from "jquery";
    import {gatewayService} from '@/common/api.service'
    import {KTApp} from '@/plugins/core/app'
    import toastr from "toastr";
    import { shaparakService } from '@/common/api.service'
    import shaparakRequests from "./shaparak-requests";

    export default {
        components: {
            shaparakInfo,
            pspRequests,
            shaparakRequests
        },
        data() {
            return {
                currentTab: 1,
                is_starshop: this.$route.params.gateway_source === 'starshop-gateways',
            }
        },
        computed: {
            ...mapGetters('gateway', [
                'form_data', 'status'
            ]),
            ...mapGetters('address', [
                'addresses'
            ]),
            ...mapGetters('shebaNumber', [
                'sheba_numbers'
            ]),
            ...mapGetters('pspRequest', [
                'shop_psp_requests_status',
                'shop_psp_requests',
                'current_psp_tab',
            ]),
            ...mapGetters('shaparak', [
                'shop_shaparak_requests_status',
                'shop_shaparak_requests',
                'shaparak_info_tab',
            ]),
            toastr() {
                toastr.options = {
                    closeButton: true,
                    positionClass: "toast-bottom-center",
                    preventDuplicates: false,
                    rtl: false,
                    progressBar: true
                }
                return toastr
            },
        },
        methods: {
            gotoTab(selectedTab) {
                this.currentTab = selectedTab;
            },
            registerTerminal(e) {
                let btn = e.submitter;
                let psp_list = []
                psp_list.push(this.current_psp_tab)

                let params = {
                    psp_list : psp_list
                }
                KTApp.progress(btn)
                gatewayService.createTerminal(this.$route.params.hashid, params, this.is_starshop)
                    .then(response => {
                        this.toastr.success(response.data.message)
                    })
                    .catch(({response}) => {
                        this.toastr.error(response.data.message)
                    })
                    .finally(() => {
                        KTApp.unprogress(btn)
                        this.refreshPspRequests()
                    })
            },
            sendNewTerminalRequest(e) {
                this.$store.commit('shaparak/setShaparakInfoTab', true)
                let hashid = this.$route.params.hashid
                let btn = e.target;
                KTApp.progress(btn)

                let params = {
                    shop_id: hashid,
                    psp: this.current_psp_tab
                }
                shaparakService.resendNewTerminalRequest(params, this.is_starshop)
                    .then(response => {
                        this.toastr.success(response.data.message)
                    })
                    .catch(({response}) => {
                        this.toastr.error(response.data.message)
                    })
                    .finally(() => {
                        this.refreshShaprakRequests()
                        KTApp.unprogress(btn)
                    })
            },
            refreshPspRequests() {
                this.$store.dispatch('pspRequest/fetchByShopId', {
                    hashid: this.$route.params.hashid,
                    is_starshop: this.is_starshop
                })
                    .finally(() => {
                        $('#tab_' + this.current_psp_tab).click()
                        this.$store.commit('pspRequest/setPspRequests', this.shop_psp_requests[this.current_psp_tab])
                    })
            },
            refreshShaprakRequests() {
                this.$store.dispatch('shaparak/fetchShopShaparakRequests', {
                    hashid: this.$route.params.hashid,
                    is_starshop: this.is_starshop
                })
                    .finally(() => {
                        $('#tab_' + this.current_psp_tab).click()
                        this.$store.commit('shaparak/setShaparakRequests', this.shop_shaparak_requests[this.current_psp_tab])
                    })
            }
        },
        mounted() {
            if (this.shaparak_info_tab) {
                this.currentTab = 2;
            }
        }
    }
</script>